import { CardSummary, CardType, PaymentToken, paymentSolutionType, paymentSolutionTypes } from './types';

export const getSupportedCards = (): CardType[] => {
  const cardListFromConfig = process.env.REACT_APP_ACCEPTED_CARDS;
  if (cardListFromConfig) {
    const supportCards = cardListFromConfig.split(',').map((x) => {
      const cardDetails = x.split('-');
      const card: CardType = {
        cardId: cardDetails[0],
        cardName: cardDetails[1],
      };
      return card;
    });
    return supportCards;
  }
  return [];
};
const getCardNameFromType = (cardType: string): string => {
  const supportedCard = getSupportedCards();
  const filteredCardNames = supportedCard.filter((x) => x.cardId === cardType);
  const cardName = filteredCardNames && filteredCardNames.length > 0 ? filteredCardNames[0].cardName : '';
  return cardName;
};
export const getMaskedCardInformationFromToken = (token: string): CardSummary => {
  const tokenObject: PaymentToken = JSON.parse(atob(token?.split('.')[1]));
  console.log({ tokenObject: tokenObject });
  let cardSummary: CardSummary = {
    cardType: '',
    cardName: '',
    expiration: '',
    maskedCardNumber: '',
    isCreditCard: false,
  };
  if (tokenObject.content.paymentInformation.card) {
    const card = tokenObject.content.paymentInformation.card;
    const maskedCardNumber = card.number.maskedValue;
    const expirationMonth = card.expirationMonth.value;
    const expirationYear = card.expirationYear.value;
    const type = card.type.value;
    const expiration =
      expirationYear.length > 2
        ? `${expirationMonth}${expirationYear.substr(2)}`
        : `${expirationMonth}${expirationYear}`;
    const cardName = getCardNameFromType(type);
    cardSummary = {
      cardType: cardName,
      cardName: cardName,
      expiration: expiration,
      maskedCardNumber: maskedCardNumber,
      isCreditCard: true,
    };
  } else {
    const paymentSolutionType = getPaymentTypeFromToken(token);
    cardSummary.cardType = paymentSolutionType.type;
    cardSummary.cardName = paymentSolutionType.text;
  }

  return cardSummary;
};
export const getPaymentTypeFromToken = (token: string): paymentSolutionType => {
  const tokenObject: PaymentToken = JSON.parse(atob(token?.split('.')[1]));
  // NOTE: processingInformation is not returned in transientToken API (nor the Payment-Details cybersource API)
  let paymentSolutionValue = '';
  if (tokenObject.content.paymentInformation.card) {
    paymentSolutionValue = 'CC';
  }
  if (tokenObject.content.processingInformation) {
    paymentSolutionValue = tokenObject.content.processingInformation.paymentSolution.value;
  }
  return paymentSolutionTypes.find(({ value }) => value === paymentSolutionValue) || { value: '', type: '', text: '' };
};
